import { differenceInSeconds } from 'date-fns';

export const getJobCompletionPercentage = (
  status: string,
  estimatedEndAt: string,
  createdAt: string,
) => {
  if (
    status === 'success' ||
    status === 'partially_success' ||
    status === 'failed' ||
    status === 'cancelled' ||
    status === 'timeout'
  ) {
    return 100;
  }
  if (!estimatedEndAt) {
    return 0;
  }
  const elapsedTime = differenceInSeconds(new Date(), new Date(createdAt));
  const totalTime = differenceInSeconds(new Date(estimatedEndAt), new Date(createdAt));
  return Math.min(99, Math.round((elapsedTime / totalTime) * 100));
};
